<script setup lang="ts">
import { ref, type Ref, computed } from 'vue'
import OGHeader from '@/components/OGHeader.vue'
import { useAppStore, type Calendar, type Meeting, type Profile } from '@/stores/appStore'
import { useAuthStore } from '@/stores/authStore'
import ProfilesList from '@/components/ProfilesList.vue'
import MeetingsList from '@/components/MeetingsList.vue'
import HomepageInsights from '@/components/HomepageInsights.vue'
import MeetingInsights from '@/components/MeetingInsights.vue'

const loading = ref(false)
const appstore = useAppStore()
const authStore = useAuthStore()
const meetings: Ref<Meeting[]> = ref([])
const calendars: Ref<Calendar[]> = ref([])
const profiles: Ref<Profile[]> = ref([])
const profilesThisMonth: Ref<Profile[]> = ref([])

const greeting = computed(() => {
  const hour = new Date().getHours()
  if (!authStore.user) return 'Welcome'
  if (hour < 12) return `Good Morning, ${authStore.user.firstName}`
  if (hour < 18) return `Good Afternoon, ${authStore.user.firstName}`
  return `Good Evening, ${authStore.user.firstName}`
})

const dayAndDate = computed(() => {
  const now = new Date()
  return now.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
})

const fetchData = async () => {
  loading.value = true
  const res = await appstore.fetchData()
  meetings.value = res.meetings || []
  calendars.value = res.calendars || []
  profiles.value = res.profiles || []
  profilesThisMonth.value = (res.profiles || []).filter((profile: Profile) => {
    return new Date(profile.createdAt).getMonth() === new Date().getMonth()
  })
  loading.value = false
}
fetchData()
</script>

<template>
  <OGHeader :title="greeting" :subtitle="dayAndDate" />
  <HomepageInsights :profiles="profiles" :meetings="meetings" />
  <div class="row justify-between">
    <div class="text-h5 q-mt-lg q-mb-md">Upcoming Meetings</div>
    <a :href="`/events`" v-if="meetings.length > 3" class="self-center"> View all <q-icon name="mdi-arrow-right" /> </a>
  </div>
  <MeetingsList v-if="!loading" :meetings="meetings" :max-view="3" :show-past="false" :show-removed="false" />
  <div class="row justify-between">
    <div class="text-h5 q-mt-lg q-mb-md">People You'll Meet</div>
    <a :href="`/profiles`" v-if="profiles.length > 4" class="self-center">
      View all <q-icon name="mdi-arrow-right" />
    </a>
  </div>
  <ProfilesList :profiles="profiles" :max-view="4" :compact="true" />
  <MeetingInsights :meetings="meetings" class="q-pt-md" />
</template>
